import numeral from "numeral";

import { cn } from "../../../../utils/useFunctions";
import { PdfCardGray, PdfCardWhite } from "../../../pdf/component/pdf.c.card";
import PdfLine from "../../../pdf/component/pdf.c.line";
import { STYLE_PDF_TEXT_MEDIUM_11, STYLE_PDF_TEXT_MEDIUM_12, STYLE_PDF_TEXT_MEDIUM_BLUE_11 } from "../../../pdf/styles/pdf.style";

function FuturePlanIncomeDetail({ datalist = [] }) {
  return (
    <div>
      {datalist?.map((item, index) => {
        return (
          <PdfCardWhite
            key={index}
            className={cn("flex flex-col space-y-2 px-3")}
          >
            <div className={cn(STYLE_PDF_TEXT_MEDIUM_12, "text-left text-base")}>
              {item?.title}
            </div>
            <PdfLine />
            <div className="flex items-center space-x-2">
              <div>
                <img src={`/images/${item.icon}`} />
              </div>
              <div className={cn(STYLE_PDF_TEXT_MEDIUM_11, "text-base")}>{item?.label}</div>
            </div>
            <PdfCardGray className={cn("px-2")}>
              <div className="flex justify-between space-y-1">
                <div className={cn(STYLE_PDF_TEXT_MEDIUM_11, "text-base")}>
                  {"คาดการณ์ไว้อีก"}
                </div>
                <div
                  className={cn(
                    STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                    "flex space-x-2 text-base"
                  )}
                >
                  {`${item?.year} ปี`}
                </div>
              </div>
              {!item?.is_rent && (
                <div className="flex justify-between space-y-1">
                  <div className={cn(STYLE_PDF_TEXT_MEDIUM_11, "text-base")}>
                    {"จำนวนเงิน"}
                  </div>
                  <div
                    className={cn(
                      STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                      "flex space-x-2 text-base"
                    )}
                  >
                    {`${numeral(item?.amount).format("0,0")} บาท`}
                  </div>
                </div>
              )}
              {item?.is_rent && (
                <div className="flex justify-between space-y-1">
                  <div className={cn(STYLE_PDF_TEXT_MEDIUM_11, "text-base" )}>
                    {"ระยะเวลาที่จะมีรายรับ (ปี)"}
                  </div>
                  <div
                    className={cn(
                      STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                      "flex space-x-2 text-base"
                    )}
                  >
                    {`${numeral(item?.year_rent).format("0,0")} ปี`}
                  </div>
                </div>
              )}
              {item?.is_rent && (
                <div className="flex justify-between space-y-1">
                  <div className={cn(STYLE_PDF_TEXT_MEDIUM_11, "text-base")}>
                    {"จำนวนเงินที่ได้ต่อปี"}
                  </div>
                  <div
                    className={cn(
                      STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                      "flex space-x-2 text-base"
                    )}
                  >
                    {`${numeral(item?.amount_perYear).format("0,0")} บาท`}
                  </div>
                </div>
              )}
            </PdfCardGray>
          </PdfCardWhite>
        );
      })}
    </div>
  );
}

export default FuturePlanIncomeDetail;
